import React from 'react';
import { Link } from 'react-router-dom';

export const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-[#FAF8F5]" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="font-['Bodoni_Moda'] text-4xl font-bold text-[#2A2A2A] mb-8">
          Privacy Policy
        </h1>

        <div className="prose prose-lg max-w-none text-[#444]">
          <p className="text-sm text-[#666] mb-8">Last updated: January 2026</p>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Information We Collect
          </h2>
          <p>
            When you make a purchase or interact with our site, we may collect personal information including your name, email address, shipping address, phone number, and payment information. We also collect information about your browsing behavior on our site.
          </p>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            How We Use Your Information
          </h2>
          <p>We use the information we collect to:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Process and fulfill your orders</li>
            <li>Communicate with you about your orders</li>
            <li>Send you marketing communications (with your consent)</li>
            <li>Improve our website and services</li>
            <li>Comply with legal obligations</li>
          </ul>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Information Sharing
          </h2>
          <p>
            We do not sell your personal information. We may share your information with service providers who help us operate our business (shipping carriers, payment processors, etc.) and as required by law.
          </p>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Cookies
          </h2>
          <p>
            We use cookies and similar technologies to enhance your browsing experience, analyze site traffic, and personalize content. You can control cookie preferences through your browser settings.
          </p>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Your Rights
          </h2>
          <p>
            You have the right to access, update, or delete your personal information. You may also opt out of marketing communications at any time by clicking the unsubscribe link in our emails.
          </p>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Contact Us
          </h2>
          <p>
            If you have questions about this Privacy Policy, please{' '}
            <Link to="/contact" className="text-[#D4540A] hover:underline">
              contact us
            </Link>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
